import React from 'react';
import PropTypes from 'prop-types';
import DataTableColumnSort from './DataTableColumnSort';
import DataTableColumnFilter from './DataTableColumnFilter';
import styled from 'styled-components';
import { DataTableColumnDatePickerWrapper } from '../DataTableColumnDatePicker/DataTableColumnDatePickerWrapper';

const DataTableHeaderCellWithIcons = styled.div`
  display: inline-flex;
  align-items: center;
`;

const DataTableHeaderCellIcon = styled.div`
  display: inline-flex;
  align-items: center;
`;

const DataTableColumnWithIcons = (props) => {
  const { id, children, options, align = 'left', orderBy, order, onOrderClick, currentFilter, setCurrentFilter, width, onFilterOpen } = props;

  const handleOrderClick = () => {
    if (options && options.sortable) {
      onOrderClick(id);
    }
  };

  const sortIcon = options && options.sortable && (
    <DataTableColumnSort active={orderBy === id} direction={orderBy === id ? order : null} onOrderClick={handleOrderClick} />
  );

  const filterIcon = options && options.filterable && (
    <DataTableColumnFilter
      id={id}
      onFilterOpen={onFilterOpen}
      active={currentFilter.length > 0}
      currentFilter={currentFilter}
      setCurrentFilter={setCurrentFilter}
    />
  );

  const datePickerIcon = options && options.canSelectDateRange && (
    <DataTableColumnDatePickerWrapper onFilterOpen={onFilterOpen} setCurrentFilter={setCurrentFilter} />
  );

  return (
    <DataTableHeaderCellWithIcons style={{ width: width || '*', justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }}>
      {align === 'right' && (filterIcon || sortIcon) && (
        <DataTableHeaderCellIcon>
          {filterIcon} {sortIcon} {datePickerIcon}
        </DataTableHeaderCellIcon>
      )}
      <div className={options && options.sortable ? 'sortable' : null} onClick={options && options.sortable ? handleOrderClick : null}>
        {children}
      </div>
      {align === 'left' && (filterIcon || sortIcon) && (
        <DataTableHeaderCellIcon>
          {sortIcon} {filterIcon} {datePickerIcon}
        </DataTableHeaderCellIcon>
      )}
    </DataTableHeaderCellWithIcons>
  );
};

DataTableColumnWithIcons.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  options: PropTypes.shape({
    sortable: PropTypes.bool,
    filterable: PropTypes.bool,
    canSelectDateRange: PropTypes.bool,
  }),
  orderBy: PropTypes.string,
  order: PropTypes.string,
  onOrderClick: PropTypes.func,
  currentFilter: PropTypes.array,
  setCurrentFilter: PropTypes.func,
  width: PropTypes.string,
  onFilterOpen: PropTypes.func,
};

export default DataTableColumnWithIcons;
